<kendo-dialog-titlebar (close)="close()">
  <div class="ss-dialog-title">
    {{ title | translate }}
  </div>
</kendo-dialog-titlebar>
<!-- CONTENT -->
<div class="ss-dialog-content" id="message"></div>
<!-- BUTTONS -->
<kendo-dialog-actions>
  <button
    kendoButton
    themeColor="base"
    (click)="ok()"
    class="ss-pop-alert-button"
  >
    {{ "shared.button.ok" | translate }}
  </button>
</kendo-dialog-actions>
